module.exports = __webpack_public_path__ + "img/rivese.2220c6de.png";